// "View as": an administrator previews BR OS as one of his team sees it.
//
// The chosen email is stored in localStorage and sent as X-View-As on every
// request; the backend scopes the response to that user and refuses writes.
// Entering or leaving the preview does a full reload so no cached admin data
// survives into the preview (or the other way round).
const KEY = "br_view_as";
const NAME_KEY = "br_view_as_name";

export function getViewAs() {
  try {
    return localStorage.getItem(KEY) || "";
  } catch {
    return "";
  }
}

export function getViewAsName() {
  try {
    return localStorage.getItem(NAME_KEY) || getViewAs();
  } catch {
    return "";
  }
}

export function startViewAs(email, name = "") {
  if (!email) return;
  localStorage.setItem(KEY, email.toLowerCase());
  localStorage.setItem(NAME_KEY, name || email);
  window.location.assign("/");
}

export function stopViewAs(redirectTo = "/admin/team-access") {
  localStorage.removeItem(KEY);
  localStorage.removeItem(NAME_KEY);
  window.location.assign(redirectTo);
}
